import "antd/dist/antd.css";

import {makeStyles} from "@mui/styles";
import {Layout, Menu} from "antd";
import clsx from "clsx";
import React, {useEffect} from "react";
import {Link} from "react-router-dom";

import {Terms} from "../terms/Terms";

const {Header} = Layout;

const useStyles = makeStyles(
  () => ({
    contentBox: {
      display: "inline-block",
      height: "100%",
    },
    header: {
      background: "#f7f7f7",
      display: "flex",
      height: "70px",
      justifyContent: "space-between",
      lineHeight: "70px",
      position: "fixed",
      width: "100%",
      zIndex: 3,
    },
    headerWhite: {
      background: "white",
      display: "flex",
      height: "70px",
      justifyContent: "space-between",
      lineHeight: "70px",
      position: "fixed",
      width: "100%",
      zIndex: 3,
    },
    icon: {
      height: "62.5%",
      width: "135px",
    },
    logo: {
      background: "None",
      color: "#3E4044",
      fontFamily: "sans-serif",
      fontSize: "15px",
      fontWeight: "bold",
      height: "100%",
      margin: "0",
      textAlign: "left",
      width: "100px",
    },
    menu: {
      background: "None",
      borderBottom: "None",
      height: "100%",
    },
    menuItem: {
      color: "#3E4044",
      fontFamily: "sans-serif",
      fontSize: "15px",
      fontWeight: "bold",
    },
    // root: {
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   "& .ant-menu-horizontal > .ant-menu-item": {
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     "&:hover": {
    //       borderBottom: "None",
    //       color: "#3E4044",
    //     },
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   "& .ant-menu-horizontal > .ant-menu-item-active": {
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   "& .ant-menu-horizontal > .ant-menu-submenu": {
    //     // eslint-disable-next-line @typescript-eslint/naming-convention
    //     "&:hover": {
    //       borderBottom: "None",
    //       color: "#3E4044",
    //     },
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   "& .ant-menu-horizontal > .ant-menu-submenu-active": {
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   ".ant-menu-horizontal > .ant-menu-item-open": {
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   ".ant-menu-horizontal > .ant-menu-item-selected": {
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   ".ant-menu-horizontal > .ant-menu-submenu-open": {
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    //   // eslint-disable-next-line @typescript-eslint/naming-convention
    //   ".ant-menu-horizontal > .ant-menu-submenu-selected": {
    //     borderBottom: "None",
    //     color: "#3E4044",
    //   },
    // },
  }),
  {
    name: "SiteHeaderTc",
  }
);

export const SiteHeaderTc: React.FC = () => {
  let isMounted = false;
  const [, setIsLoading] = React.useState(false);
  const [, setIsShownTerms] = React.useState<boolean>(false);
  const [headerClass, setHeaderClass] = React.useState<string>("header");

  const classes = useStyles();

  useEffect(() => {
    // componentDidMount
    // Anything in here is fired on component mount.
    window.scrollTo(0, 0);

    isMounted = true;
    if (isMounted) {
      setIsLoading(false);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      // componentWillUnmount
      // Anything in here is fired on component unmount.
      isMounted = false;
    };
  }, []);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setHeaderClass("header-white");
    } else {
      setHeaderClass("header");
    }
  };

  const changePage = (didShown: boolean) => {
    window.scrollTo(0, 0);
    setIsShownTerms(didShown);
  };

  const menuItems = [
    {
      className: classes.menuItem,
      icon: <Link to="/t_c">Terms of Service</Link>,
      key: "1",
    },
    {
      className: classes.menuItem,
      icon: <Link to="/privacy">Privacy Policy</Link>,
      key: "2",
    },
    {
      className: classes.menuItem,
      icon: <Link to="/">Homepage</Link>,
      key: "3",
    },
  ];

  return (
    <div>
      <Header
        className={clsx({
          [classes.header]: headerClass == "header",
          [classes.headerWhite]: headerClass == "header-white",
        })}
      >
        <Link to="/">
          <div className={classes.logo}>
            <img src="/top_bar_icon.png" className={classes.icon} alt="" />
          </div>
        </Link>

        <Menu className={classes.menu} mode="horizontal" items={menuItems} />
      </Header>

      <div className={classes.contentBox}>
        <Terms />
      </div>
    </div>
  );
};
